import { parseFeed } from "htmlparser2";
import { isCriticalIncident } from "./is-critical-incident";
import { isIncidentResolved } from "./is-incident-resolved";

export function isProviderOperational(atomFeed: string): boolean {
  const feed = parseFeed(atomFeed, {});

  if (!feed) {
    return false;
  }

  const criticalIncidents = feed.items.filter(
    (item) => item.title && isCriticalIncident(item.title)
  );

  const areAllIncidentsResolved = criticalIncidents.every((incident) =>
    isIncidentResolved(incident.description)
  );

  return areAllIncidentsResolved;
}
